var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.38 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 10px;\n      }\n\n      .cls-2 {\n        fill: #10519e;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.33,32.6h-30.39v19.86c0,3.61-2.93,6.54-6.54,6.54h-61.43c-3.61,0-6.54-2.93-6.54-6.54v-19.87H11.05c-6.1,0-11.05,4.95-11.05,11.05v201.29c0,6.1,4.95,11.05,11.05,11.05h135.27c6.1,0,11.05-4.95,11.05-11.05V43.65c0-6.1-4.95-11.05-11.05-11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.29,14.35h-11.85c0-7.92-6.42-14.35-14.35-14.35s-14.35,6.42-14.35,14.35h-12.66c-1.38,0-2.5,1.12-2.5,2.5v31.5c0,1.38,1.12,2.5,2.5,2.5h53.2c1.38,0,2.5-1.12,2.5-2.5v-31.5c0-1.38-1.12-2.5-2.5-2.5ZM79.09,22.79c-4.67,0-8.45-3.78-8.45-8.45s3.78-8.45,8.45-8.45,8.45,3.78,8.45,8.45-3.78,8.45-8.45,8.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16 82.89 24.55 96.63 52.33 74.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.76,
    y1: 85.49,
    x2: 129.26,
    y2: 85.49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16 145.83 24.55 159.57 52.33 137.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.76,
    y1: 148.43,
    x2: 129.26,
    y2: 148.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16 208.77 24.55 222.51 52.33 200.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.76,
    y1: 211.37,
    x2: 129.26,
    y2: 211.37
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset30);
export default __webpack_public_path__ + "static/media/Asset 30.b030727d30aa468c1f9131fd684f3d3e.svg";
export { ForwardRef as ReactComponent };